export default {
  selectKf: "Please select customer service",
  table: {
    name: "Nickname",
    username: "Username",
    avatar: "Avatar",
    introduction: "Intro",
    status: "Status",
    totalConversation: "Number of conversations",
    avgResponseTime: "Average response time(s)",
    avgFinishTime: "Average session duration(s)",
    scoreCnt: "Number of score",
    scoreAvg: "Average score",
    createdAt: "Created",
    editTag: "Edit Tag",
  },
  message: {
    userNameLength: "Username must be 5-20 characters",
    resetPasswordConfirmation: "Are you sure to reset '{val}' password?",
  },
  form: {
    userName: "Service",
    roleId: "Role",
    tag: "Tag",
  },
};
